import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { environment } from '../../../environments/environment';

import { ITipoTelefono, IGenericResult, IAbonadoSeguridad } from 'src/app/models/abonado.model';
import { HTTPOPTIONS } from 'src/app/common/constants';


@Injectable({
  providedIn: 'root'
})
export class AbonadoseguridadService {

  private abonadoSeguridadUrl = environment.apiBaseUrl + 'abonadoseguridad';

  constructor(private http: HttpClient) { }

  public listarTelefonos ( idabonado: number ) {
    return this.http.post(this.abonadoSeguridadUrl + '/listar', { 'idabonado': idabonado }, HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult<IAbonadoSeguridad>) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error);
        })
      );
  }

  public tipoTelefonos ( ) {
    return this.http.post(this.abonadoSeguridadUrl + '/tipo', null, HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult<ITipoTelefono>) => {
          return resp.data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error);
        })
      );
  }

  public nuevoTelefono ( body: IAbonadoSeguridad ) {
    return this.http.post(this.abonadoSeguridadUrl + '/nuevo', JSON.stringify(body), HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error);
        })
      );
  }

  public actualizarTelefono ( body: IAbonadoSeguridad ) {
    return this.http.post(this.abonadoSeguridadUrl + '/actualizar', JSON.stringify(body), HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error);
        })
      );
  }

  public eliminarTelefono ( body: IAbonadoSeguridad ) {
    return this.http.post(this.abonadoSeguridadUrl + '/eliminar', JSON.stringify(body), HTTPOPTIONS)
      .pipe(
        map((resp: IGenericResult) => {
          return resp;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error);
        })
      );
  }

}
